import { TComponentNames } from '@monorepo/types';
import { TTvDashboardActions } from './tv-dashboard.actions';
import { TTvDashboardActionType, TTvDashboardState } from './tv-dashboard.model';

const initialState: TTvDashboardState = {
  connectionStatus: 'DISCONNECTED',
  messages: {
    'dwt-semi-circle-progress-widget': {},
    'dwt-metric-info-widget': {},
    'dwt-matrice-numbers-widget': {},
    'dwt-linear-progress-widget': {},
    'dwt-centralized-table-widget': {},
    'dwt-header-widget': {},
    'dwt-horizontal-numbers-widget': {},
    'dwt-vertical-numbers-widget': {},
    'dwt-progress-gauge-simple-widget': {},
    'dwt-list-widget': {},
    'dwt-sub-header-widget': {},
    'dwt-wip-break-down-table-widget': {},
    'dwt-info-card-widget': {},
    'dwt-measles-chart-widget': {},
    'dwt-dual-bar-chart-component': {},
    'dwt-progress-gauge-widget': {},
    'dwt-flip-sub-header-widget': {},
    'dwt-vertical-progress-gauge-widget': {},
    'dwt-multi-image-widget': {},
    'dwt-dashboard-table-widget': {},
  },
  channelToComponentMap: {},
};

export function tvDashboardStoreStateReducer(state = initialState, action: TTvDashboardActions): TTvDashboardState {
  switch (action.type) {
    case TTvDashboardActionType.ConnectionStatus:
      return { ...state, connectionStatus: action.connectionStatus };
    case TTvDashboardActionType.UpdateData:
      return handleUpdateData(state, action);
    case TTvDashboardActionType.MapChannelToComponent:
      return {
        ...state,
        channelToComponentMap: {
          ...state.channelToComponentMap,
          [action.channelId]: action.componentName,
        },
      };
    default:
      return state;
  }
}

function handleUpdateData(state: TTvDashboardState, action: TTvDashboardActions): TTvDashboardState {
  const { channelId, message } = action as { channelId: string; message: unknown };
  const componentName = state.channelToComponentMap[channelId];

  switch (componentName) {
    case 'dwt-semi-circle-progress-widget':
    case 'dwt-metric-info-widget':
    case 'dwt-matrice-numbers-widget':
    case 'dwt-linear-progress-widget':
    case 'dwt-centralized-table-widget':
    case 'dwt-horizontal-numbers-widget':
    case 'dwt-vertical-numbers-widget':
    case 'dwt-progress-gauge-simple-widget':
    case 'dwt-list-widget':
    case 'dwt-sub-header-widget':
    case 'dwt-wip-break-down-table-widget':
    case 'dwt-info-card-widget':
    case 'dwt-measles-chart-widget':
    case 'dwt-dual-bar-chart-component':
    case 'dwt-progress-gauge-widget':
    case 'dwt-vertical-progress-gauge-widget':
    case 'dwt-flip-sub-header-widget':
    case 'dwt-multi-image-widget':
    case 'dwt-dashboard-table-widget':
      return updateMessages(state, componentName, channelId, message);
    default:
      return state;
  }
}

function updateMessages<T>(
  state: TTvDashboardState,
  componentType: TComponentNames,
  channelId: string,
  message: T,
): TTvDashboardState {
  return {
    ...state,
    messages: {
      ...state.messages,
      [componentType]: {
        ...state.messages[componentType],
        [channelId]: message,
      },
    },
  };
}
